export const D2Categories = {
  Postmaster: ['Engrams', 'LostItems', 'Messages', 'SpecialOrders'],
  Weapons: ['Kinetic', 'Energy', 'Power'],
  Armor: ['Helmet', 'Gauntlets', 'Chest', 'Leg', 'ClassItem'],
  General: [
    'Class',
    'Ghost',
    'Emblems',
    'Ships',
    'Vehicle',
    'Finishers',
    'SeasonalArtifacts',
    'ClanBanners',
  ],
  Inventory: ['Consumables', 'Modifications', 'Shaders'],
};
